import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL
const getRound = async (offset = 0, itemsPerPage = 0, activePage = 0, params = []) => {
  const response = await agent.get(
    `${API_URL}rounds/listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const saveRound = async (data) => {
  const response = await agent.post(API_URL + 'rounds/save-round', data)
  return response.data
}
const editRound = async (data) => {
  const response = await agent.post(API_URL + 'rounds/edit-round', data)
  return response.data
}
const getRoundDetail = async (id) => {
  const response = await agent.get(`${API_URL}rounds/round-details/${id}`)
  return response.data
}
const getRoundPreview = async () => {
  const response = await agent.get(`${API_URL}rounds/preview`)
  return response.data
}

const getRoundDropDown = async (id) => {
  const response = await agent.get(`${API_URL}getRoundDropDown`)
  return response.data
}
const deleteRound = async (data) => {
  const response = await agent.post(API_URL + 'rounds/delete-round', data)
  return response.data
}
const updateRestrictAndFreeTradeStatus = async (data) => {
  const response = await agent.post(API_URL + 'rounds/updateRestrictAndFreeTradeStatus', data)
  return response.data
}

const deleteAllRound = async (data) => {
  const response = await agent.post(API_URL + 'rounds/deleteAllRound', data)
  return response.data
}
const importRound = async (data) => {
  const response = await agent.post(API_URL + 'rounds/import', data)
  return response.data
}

const getImportContext = async () => {
  const response = await agent.get(`${API_URL}rounds/import-context`)
  return response.data
}

const RoundService = {
  getImportContext,
  updateRestrictAndFreeTradeStatus,
  getRound,
  getRoundPreview,
  saveRound,
  deleteRound,
  getRoundDetail,
  editRound,
  getRoundDropDown,
  deleteAllRound,
  importRound,
}

export default RoundService
